import React from 'react'
import { Helmet } from 'react-helmet'
import { generateAlternateLinks, generateTitleAndMetaTags } from 'src/utils/seo'

const SeoCsLearning = ({ title, description }) => {
  return (
    <Helmet>
      {generateTitleAndMetaTags(title, description)}
      {generateAlternateLinks('/education/countersketch')}
      <script type='application/ld+json'>
        {`{
          "@context": "https://schema.org/", 
          "@type": "BreadcrumbList", 
          "itemListElement": [{
            "@type": "ListItem", 
            "position": 1, 
            "name": "CounterSketch Learning",
            "description": "Training programs for first-time CAD users. Whether you are a novice, expert, student, or professional, we have a training path for you. Choose the option best suited to your style of learning.",
            "item": "https://gemvision.com/education/countersketch"  
          }]
        }`}
      </script>
    </Helmet>
  )
}

export default React.memo(SeoCsLearning)
